import {
  AcceptDelegationLandingModel,
  ActiveDelegationModel,
  CreateDelegationInvitationModel,
  DelegationContextModel,
  DelegationHistoryModel,
  DelegationInvitationCreatedModel,
  DelegationInvitationListItemModel,
  SwitchDelegationModel,
  UpdateDelegationPermissionsModel,
  UpdateDelegationValidityModel,
} from "../interfaces/delegation";
import {
  del,
  get,
  getAnonymous,
  patchJson,
  patchJsonWithoutAuthRedirect,
  post,
} from "./util";

export async function createDelegationInvitation(
  model: CreateDelegationInvitationModel,
) {
  return post<DelegationInvitationCreatedModel>({
    query: "Delegations/invitations",
    body: model,
  });
}

export async function listDelegationInvitations() {
  return get<DelegationInvitationListItemModel[]>({
    query: "Delegations/invitations",
  });
}

export async function revokeDelegationInvitation(id: string) {
  await del({
    query: `Delegations/invitations/${id}`,
  });
}

export async function listActiveDelegations() {
  return get<ActiveDelegationModel[]>({
    query: "Delegations/active",
  });
}

export async function listDelegationHistory() {
  return get<DelegationHistoryModel[]>({
    query: "Delegations/history",
  });
}

export async function revokeDelegation(id: string) {
  await del({
    query: `Delegations/${id}`,
  });
}

export async function updateDelegationPermissions(
  id: string,
  model: UpdateDelegationPermissionsModel,
) {
  return patchJson({
    query: `Delegations/${id}`,
    body: model,
  });
}

export async function updateDelegationValidity(
  id: string,
  model: UpdateDelegationValidityModel,
) {
  return patchJsonWithoutAuthRedirect({
    query: `Delegations/${id}/validity`,
    body: model,
  });
}

export async function switchDelegation(model: SwitchDelegationModel) {
  return post<{ success: boolean }>({
    query: "Delegations/switch",
    body: model,
  });
}

export async function switchToSelfSession() {
  return post<{ success: boolean }>({
    query: "Delegations/switch-self",
    body: {},
  });
}

export async function getDelegationContext() {
  return get<DelegationContextModel>({
    query: "Delegations/context",
  });
}

export async function getDelegationAcceptLanding(token: string) {
  return getAnonymous<AcceptDelegationLandingModel>({
    query: `DelegationAccept?token=${encodeURIComponent(token)}`,
  });
}
